<template>
  <public-page>
    <div class="home">
      <description-card />
      <services-card />
      <testimonials-card />
      <credentials-card />
      <contact-card />
    </div>
  </public-page>
</template>

<script>
import PublicPage from './PublicPage'
import DescriptionCard from '../cards/DescriptionCard'
import ServicesCard from '../cards/ServicesCard'
import TestimonialsCard from '../cards/TestimonialsCard'
import CredentialsCard from '../cards/CredentialsCard'
import ContactCard from '../cards/ContactCard'

export default {
  name: 'home',
  components: {
    PublicPage,
    DescriptionCard,
    ServicesCard,
    TestimonialsCard,
    CredentialsCard,
    ContactCard,
  },
}
</script>

<style lang="scss">
.home {
  width: 100%;
}
</style>
